import {AfterViewInit, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-tuto',
  templateUrl: './tuto.component.html',
  styleUrls: ['./tuto.component.scss']
})
export class TutoComponent implements AfterViewInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<TutoComponent>,
        public trackingService: TrackingService
    ) {
        // Tracking centralisé : toute ouverture de la popup tuto envoie le nom de la vidéo,
        // quel que soit l'endroit du site qui l'ouvre.
        this.trackingService.click('tuto_video_open', this.data.video);
    }

    // Lecteur Vidyard : le script du head ne scanne que le DOM initial, les players ajoutés
    // ensuite (popup) sont rendus à la demande
    ngAfterViewInit(): void {
        const vidyard = (window as any).VidyardV4;
        if (vidyard && vidyard.api && vidyard.api.renderDOMPlayers) {
            vidyard.api.renderDOMPlayers();
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
